import {getAllCountriesUseCase} from '@/useCases/getCountriesUseCase'
import {useQuery} from '@tanstack/react-query'
import {useMemo} from 'react'

export const useCountryCode = (countryCode: string) => {
  const {data} = useQuery({
    queryKey: ['countries'],
    queryFn: ({signal}) => getAllCountriesUseCase(signal),
    staleTime: Infinity,
  })

  const codeIDMap: Map<string, number> = useMemo(() => {
    return new Map(data?.map(item => [item.code, item.id]))
  }, [data])

  const codeNameMap: Map<string, string> = useMemo(() => {
    return new Map(data?.map(item => [item.code, item.name]))
  }, [data])

  const countryId = codeIDMap.get(countryCode) ?? -1
  const countryName = codeNameMap.get(countryCode) ?? ''

  return {countryId, countryName, countryCode}
}
